<template>
  <layout>
    <template v-slot:header>
      <Nav :customer="customer" />
    </template>

    <v-container>
      <v-btn @click="showQuestionForm()" class="float-right" color="secondary">{{ $t("customer.admin.votes.add") }}</v-btn>
      <h2>{{ $t("customer.admin.votes.title") }}</h2>
      <PropPanel ref="propPanel" :onSave="saveQuestion" :tabIndex="3">
        <AddQuestion ref="question" :customer="customer" type="vote" :onSaved="addQuestion" state="inactive" />
      </PropPanel>
      <VoteList ref="list" :qas="qas" :canDelete="canDelete" :onChange="loadQuestions" />
    </v-container>
  </layout>
</template>

<script>
import axios from "axios";
import Layout from "@/layouts/default";

import Nav from "@/components/_layout/navigation";
import PropPanel from "@/components/_common/proppanel.vue";
import AddQuestion from "@/components/questions/question.vue";
import VoteList from "@/components/votes/vote-list.vue";

import { mapGetters } from "vuex";
import { formatMixin, formMixin, listMixin } from "@/helpers/mixins";

export default {
  mixins: [formatMixin, formMixin, listMixin],
  components: {
    Layout,
    AddQuestion,
    PropPanel,
    VoteList,
    Nav
  },
  data: function() {
    return {
      qas: [],
      customer: this.$route.meta.customer,
      type: "vote",
    };
  },
  computed: {
    ...mapGetters(["role"]),
    canDelete: function() {
      return ["admin", "moderator"].includes(this.role);
    },
  },
  watch: {},
  mounted() {
    this.loadQuestions();
  },
  methods: {
    loadQuestions: function() {
      this.$store.dispatch("loading", true);
      axios
        .get(`/api/questions?customer=${this.customer}&type=${this.type}&state=all&details=all`)
        .then((res) => {
          this.qas = res.data;
          this.$store.dispatch("loading", false);
        })
        .catch((e) => {
          console.log(e);
        });
    },

    showQuestionForm: function() {
      this.$refs.propPanel.show();
      this.$refs.question.init();
    },
    saveQuestion: function() {
      this.$refs.question.saveQuestion();
    },
    addQuestion: function() {
      this.$refs.propPanel.hide();
      this.loadQuestions()
    },
  },
};
</script>

<style lang="scss" scoped></style>
